import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateInputFillMode } from '@progress/kendo-angular-dateinputs';
import { CheckBoxRounded } from '@progress/kendo-angular-inputs';

@Component({
  selector: 'app-special-offer-edit-dates-modal',
  standalone: false,
  templateUrl: './special-offer-edit-dates-modal.component.html',
  styleUrl: './special-offer-edit-dates-modal.component.scss',
})
export class SpecialOfferEditDatesModalComponent {
  public startDate: Date;
  public endDate: Date;
  public today: Date = new Date();

  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: CheckBoxRounded = 'large';

  constructor(private _activeModal: NgbActiveModal) {}

  disableEndDates = (date: Date): boolean => {
    if (this.startDate > this.today) {
      return date < this.startDate;
    } else {
      return date < this.today;
    }
  };

  changeHandler() {
    this._activeModal.close(this.endDate);
  }

  closeHandler() {
    this._activeModal.close(false);
  }
}
